import { zodResolver } from '@hookform/resolvers/zod';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { z } from 'zod';

import { Button, ScrollToTop } from '@/components';
import { useBookingStore } from '@/store';

const CreditCardPayment: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { balance } = useBookingStore();

  const creditCardSchema = z.object({
    cardNumber: z.string().min(16, t('validation.required')),
    expiryDate: z
      .string()
      .regex(/^(0[1-9]|1[0-2])\/([0-9]{2})$/, 'Format: MM/YY'),
    cvv: z.string().min(3, t('validation.required')),
    cardholderName: z.string().min(1, t('validation.required')),
  });

  type CreditCardForm = z.infer<typeof creditCardSchema>;

  const { handleSubmit } = useForm<CreditCardForm>({
    resolver: zodResolver(creditCardSchema),
  });

  const handlePayment = (data: CreditCardForm) => {
    // Process credit card payment
    console.log('Processing credit card payment:', data);
    navigate('/booking/thank-you');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <ScrollToTop />
      <div className="mx-auto max-w-2xl px-4">
        <h2 className="mb-6 text-2xl font-bold">{t('creditCard.title')}</h2>

        <form onSubmit={handleSubmit(handlePayment)} className="space-y-6">
          {/* Credit Card Form */}
          <div className="rounded-lg border bg-white p-6">
            <h3 className="mb-4 text-lg font-semibold">
              {t('creditCard.title')}
            </h3>

            <div className="space-y-4">
              {/* <Input
                label={t('creditCard.cardNumber')}
                {...register('cardNumber')}
                placeholder={t('creditCard.cardNumberPlaceholder')}
                error={errors.cardNumber?.message}
              /> */}

              <div className="grid grid-cols-2 gap-4">
                {/* <Input
                  label={t('creditCard.expiryDate')}
                  {...register('expiryDate')}
                  placeholder={t('creditCard.expiryPlaceholder')}
                  error={errors.expiryDate?.message}
                />
                <Input
                  label={t('creditCard.cvv')}
                  {...register('cvv')}
                  placeholder={t('creditCard.cvvPlaceholder')}
                  error={errors.cvv?.message}
                /> */}
              </div>

              {/* <TextInput
                label={t('creditCard.cardholderName')}
                {...register('cardholderName')}
                placeholder={t('creditCard.cardholderPlaceholder')}
                error={errors.cardholderName?.message}
              /> */}
            </div>
          </div>

          {/* Payment Summary */}
          <div className="rounded-lg bg-gray-50 p-4">
            <div className="flex items-center justify-between">
              <span className="font-medium">{t('payment.totalAmount')}:</span>
              <span className="text-xl font-bold text-green-600">
                {t('common.currency')}
                {balance.total.toLocaleString()}
              </span>
            </div>
          </div>

          {/* Security Notice */}
          <div className="rounded-lg bg-green-50 p-4">
            <div className="flex items-center">
              <span className="mr-2 text-green-600">🔒</span>
              <p className="text-sm text-green-700">
                {t('creditCard.secureInfo')}
              </p>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-between pt-6">
            <Button
              type="button"
              variant="secondary"
              onClick={() => navigate('/booking/summary')}
            >
              {t('common.back')}
            </Button>
            <Button type="submit">{t('creditCard.payNow')}</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreditCardPayment;
